<template>
  <div class="emptyContainer">
    <img src="../assets/images/组 23588@2x.png" alt="" />
    <p>暂无内容</p>
  </div>
</template>
<script>
export default {
  name: "Empty",
};
</script>
<style scoped>
.emptyContainer {
  margin: 12.5rem auto 0;
  font-size: 1.25rem;
}
.emptyContainer > img {
  width: 13.75rem;
  height: auto;
}
</style>